import { type FC, type ReactNode } from "react";
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  TableContainer,
} from "@mui/material";

export interface SimpleTableColumn {
  name: string;
  minWidth?: number;
  renderBody?: (value: unknown) => ReactNode;
}

interface SimpleTableProps {
  columns: SimpleTableColumn[];
  rows: unknown[][];
}

export const SimpleTable: FC<SimpleTableProps> = ({ columns, rows }) => (
  <TableContainer sx={{ overflowX: "auto" }}>
    <Table size="small">
      <TableHead>
        <TableRow>
          {columns.map((column, index) => (
            <TableCell key={index} sx={{ whiteSpace: "nowrap" }}>
              {column.name}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row, rowIndex) => (
          <TableRow key={rowIndex}>
            {columns.map((column, columnIndex) => (
              <TableCell key={columnIndex} sx={{ minWidth: column.minWidth }}>
                {column.renderBody
                  ? column.renderBody(row[columnIndex])
                  : (row[columnIndex] as ReactNode)}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);
